/* global toastr */
import React from 'react'
import Swal from 'sweetalert2'
import { wrapView, request, split_list } from '../smart_bps/lib/utils'
import { store } from '../index'
import { stateToProps } from '../smart_bps/admin/base_view'
import { BaseAdminModelView as CoreAdminModelView } from '../smart_bps/admin/model_view'
import { Link } from 'react-router-dom'
import AttrInput from '../smart_bps/lib/attr_input'
import {AuthorizedDropDownMeny, UnauthorizedDropDownMenu} from "../lib/NavDropdownMenu";

export class BaseAdminModelView extends CoreAdminModelView {
  constructor(props) {
    super(props)
    this.state = { ...(this.state || {}), showDeleteModal: false }
    this.saveObject = this.saveObject.bind(this)
    this.openDeleteConfirm = this.openDeleteConfirm.bind(this)
    this.closeDeleteConfirm = this.closeDeleteConfirm.bind(this)
    this.confirmDeleteAndClose = this.confirmDeleteAndClose.bind(this)
  }

  getDeleteConfirmTitle() {
    return 'Удаление'
  }

  openDeleteConfirm() {
    this.setState({ showDeleteModal: true })
  }

  closeDeleteConfirm() {
    this.setState({ showDeleteModal: false })
  }

  confirmDeleteAndClose() {
    this.setState({ showDeleteModal: false })
    const that = this
    request({
      method: 'post',
      url: `/api/admin/${this.model_name}/${this.object_id}/delete_object`,
      success: (data) => {
        store.dispatch({ type: 'admin_list_clean' })
        that.redirect_to(`/admin/${this.model_name}`)
        const msg = data?.message || (this.model_name === 'User' ? 'Пользователь деактивирован' : 'Успешно удалено')
        toastr.success(msg)
      },
      error: (data) => {
        toastr.error(data.detail, 'Ошибка удаления')
      },
    })
  }

  saveObject() {
    if (this.state.saving) return
    const that = this
    this.setState({ saving: true })
    request({
      method: 'post',
      url: `/api/admin/${this.model_name}/${this.object_id}/update_object`,
      data: {
        new_data: this.state.form_data,
        old_data: this.state.form_data_initial,
      },
      success: (data) => {
        const finish = () => {
          store.dispatch({ type: 'admin_list_clean' })
          if (data.form_data) {
            that.dataToState(data)
            toastr.success('Изменения сохранены')
            if (data.message) toastr.success(data.message)
          }
          if (data.errors) {
            const errs = { ...data.errors }
            if (errs._toast) {
              toastr.warning(errs._toast, 'Внимание')
              delete errs._toast
            } else {
              toastr.warning('Изменения не были сохранены. Нужно исправить ошибки в форме документа', 'Внимание')
            }
            that.setState({ form_errors: Object.keys(errs).length > 0 ? errs : undefined })
          }
        }
        that.setState({ saving: false }, finish)
      },
      error: () => {
        that.setState({ saving: false })
        toastr.error('Ошибка сохранения')
      },
    })
  }

  deleteObject() {
    this.openDeleteConfirm()
  }

  renderDeleteConfirmModal() {
    if (!this.state.showDeleteModal) return null
    return (
      <div
        className="sigur-delete-confirm-modal modal fade show"
        style={{ display: 'block' }}
        id="modal_delete_confirm_admin"
        key="delete_confirm_modal"
      >
        <div className="sigur-delete-confirm-modal__backdrop" onClick={this.closeDeleteConfirm} aria-hidden="true" />
        <div className="modal-dialog sigur-delete-confirm-modal__dialog" role="document">
          <div className="modal-content sigur-delete-confirm-modal__content">
            <div className="modal-header sigur-delete-confirm-modal__header">
              <h5 className="modal-title sigur-delete-confirm-modal__title">{this.getDeleteConfirmTitle()}</h5>
              <button type="button" className="btn-close" onClick={this.closeDeleteConfirm} aria-label="Закрыть" />
            </div>
            <div className="modal-body sigur-delete-confirm-modal__body">
              <span className="sigur-delete-confirm-modal__icon ti ti-alert-triangle" aria-hidden="true" />
              <p className="sigur-delete-confirm-modal__text mb-0">
                Это действие нельзя будет отменить. Вы уверены, что хотите удалить карточку?
              </p>
            </div>
            <div className="modal-footer px-3">
              <button type="button" className="btn btn-primary p-2 me-1" onClick={this.confirmDeleteAndClose}>
                Удалить
              </button>
              <button type="button" className="btn btn-secondary p-2 me-1" onClick={this.closeDeleteConfirm}>
                Отменить
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <>
        {super.render()}
        {this.renderDeleteConfirmModal()}
      </>
    )
  }

  renderBreadcrumbs() {
    const rawTitle = this.state && this.state.title != null ? String(this.state.title) : ''
    const safeTitle = rawTitle.replace('#None', '#---')
    return (
      <nav aria-label="breadcrumb" key="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Домой</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/admin">Админка</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/admin/${this.model_name}`}>{this.props.model_title}</Link>
          </li>
          <li className="breadcrumb-item active">{safeTitle}</li>
        </ol>
      </nav>
    )
  }

  /**
   * Как в smart_bps admin/model_view, но с локальным AttrInput (обязательные поля, mode_issue без «Не заполнено»).
   */
  renderContentLeft() {
    const view = this
    const data = this.state.form_data
    const attrs = this.props.attrs
    const form_access = this.state.form_access
    const form_access_names = Object.keys(form_access || {})
    const flowLinks = Array.isArray(data.flow_stage_links_lnk) ? data.flow_stage_links_lnk : []

    function updateFlowStageLinks(nextRows, cb) {
      view.setState(
        (prev) => ({
          form_data: {
            ...(prev.form_data || {}),
            flow_stage_links_lnk: nextRows,
          },
        }),
        cb
      )
    }

    function addFlowStageLinkRow() {
      updateFlowStageLinks([
        ...flowLinks,
        {
          document_name: '',
          is_required: false,
          track_validity_period: false,
          stages_lnk: [],
          date_types_lnk: [],
        },
      ])
    }

    function removeFlowStageLinkRow(idx) {
      Swal.fire({
      title: 'Удалить документ?',
      text: 'Строка будет удалена',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      focusConfirm: false,
      focusCancel: false,
      customClass: {
        confirmButton: 'btn btn-outline-primary',
        cancelButton: 'btn btn-outline-secondary',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const next = flowLinks.filter((_, i) => i !== idx)
        //Вызываем сохранение документа после обновлнения state.
        updateFlowStageLinks(next, () => {
          view.saveObject()
        })
      }
    })
    }

    function patchFlowStageLinkRow(idx, patch) {
      const next = flowLinks.map((row, i) => (i === idx ? { ...(row || {}), ...patch } : row))
      updateFlowStageLinks(next)
    }

    function normalizeChoiceItems(raw) {
      if (!raw) return []
      if (Array.isArray(raw)) {
        // Форматы: [[value, label], ...] или [{value,label}], [{value_id,title}] и т.п.
        return raw.map((item) => {
          if (Array.isArray(item)) return item
          if (item && typeof item === 'object') {
            const value = item.value ?? item.value_id ?? item.id ?? item.key
            const label = item.label ?? item.title ?? item.name ?? item.text ?? String(value ?? '')
            return [value, label]
          }
          return [item, String(item)]
        })
      }
      if (Array.isArray(raw.items)) return raw.items
      return []
    }

    function getChoiceItems(choiceName) {
      const src = view.props.choices
      if (!src) return []
      if (Array.isArray(src)) {
        const found = src.find((x) => x && (x.name === choiceName || x.choice_name === choiceName))
        return normalizeChoiceItems(found && (found.items || found.values || found))
      }
      return normalizeChoiceItems(src[choiceName])
    }

    function renderFlowStageLinksTable(attr) {
      const rows = Array.isArray(data.flow_stage_links_lnk) ? data.flow_stage_links_lnk : []
      const access = form_access[attr.name]
      const readOnly = access !== 'edit'
      const error = view.state.form_errors && view.state.form_errors[attr.name]
      const cardFlow = data.document_flow || null
      const colCount = readOnly ? 5 : 6
      const dateTypeItems = getChoiceItems('DocumentTypeDateType')
      const userRoles = view.props.user?.roles || []
      const canEditAdminColumns = userRoles.includes('admin') || userRoles.includes('superuser')
      const adminColumnsReadOnly = readOnly || !canEditAdminColumns
      return (
        <div key={attr.name} className="mb-3">
          {!readOnly && (
            <div className="mb-2">
              <button type="button" className="btn btn-sm btn-outline-primary" onClick={addFlowStageLinkRow}>
                + добавить документ
              </button>
            </div>
          )}
          <div className="table-responsive">
            <table className="table table-sm table-bordered align-middle mb-0">
              <thead>
                <tr>
                  <th style={{ minWidth: 200 }}>Документ</th>
                  <th style={{ minWidth: 160 }}>Обязательный документ</th>
                  <th style={{ minWidth: 240 }}>Этапы</th>
                  <th style={{ minWidth: 160 }}>Учитывать срок действия</th>
                  <th style={{ minWidth: 220 }}>Тип даты</th>
                  {!readOnly && <th style={{ width: 56 }} />}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={colCount} className="text-muted">Строки не добавлены</td>
                  </tr>
                ) : rows.map((row, idx) => {
                  const allStates = getChoiceItems('ProjectState')
                  const statesForFlow = cardFlow
                    ? allStates.filter((item) => {
                      const value = Array.isArray(item) ? item[0] : item?.value
                      return String(value || '').startsWith(`${cardFlow}:`)
                    })
                    : []
                  const stagesDisabled = readOnly || !cardFlow || statesForFlow.length === 0
                  const trackValidity = !!(row || {}).track_validity_period
                  const dateTypesDisabled = adminColumnsReadOnly || !trackValidity
                  return (
                  <tr key={`flow-link-${idx}`}>
                    <td>
                      <AttrInput
                        data_type="string"
                        name={`flow_links_doc_${idx}`}
                        title=""
                        value={(row || {}).document_name ?? ''}
                        access={readOnly ? 'read' : 'edit'}
                        onChange={(_, value) => patchFlowStageLinkRow(idx, { document_name: value || '' })}
                      />
                    </td>
                    <td>
                      <div className="form-check mt-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`flow_links_req_${idx}`}
                          checked={!!(row || {}).is_required}
                          disabled={readOnly}
                          onChange={(e) => patchFlowStageLinkRow(idx, { is_required: !!e.target.checked })}
                        />
                        <label className="form-check-label" htmlFor={`flow_links_req_${idx}`}>
                          Да
                        </label>
                      </div>
                    </td>
                    <td>
                      <AttrInput
                        data_type="m2m_string"
                        choice_name="ProjectState"
                        widget="select2"
                        name={`flow_links_stages_${idx}`}
                        title=""
                        value={(row || {}).stages_lnk || []}
                        access={stagesDisabled ? 'read' : 'edit'}
                        {...(statesForFlow.length > 0 ? { choice_items: statesForFlow } : {})}
                        choices={view.props.choices}
                        onChange={(_, value) => patchFlowStageLinkRow(idx, { stages_lnk: value || [] })}
                      />
                    </td>
                    <td>
                      <div className="form-check mt-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`flow_links_validity_${idx}`}
                          checked={trackValidity}
                          disabled={adminColumnsReadOnly}
                          onChange={(e) => {
                            const checked = !!e.target.checked
                            patchFlowStageLinkRow(idx, {
                              track_validity_period: checked,
                              date_types_lnk: checked ? ((row || {}).date_types_lnk || []) : [],
                            })
                          }}
                        />
                        <label className="form-check-label" htmlFor={`flow_links_validity_${idx}`}>
                          Да
                        </label>
                      </div>
                    </td>
                    <td>
                      <AttrInput
                        data_type="m2m_string"
                        choice_name="DocumentTypeDateType"
                        widget="select2"
                        name={`flow_links_date_types_${idx}`}
                        title=""
                        value={(row || {}).date_types_lnk || []}
                        access={dateTypesDisabled ? 'read' : 'edit'}
                        {...(dateTypeItems.length > 0 ? { choice_items: dateTypeItems } : {})}
                        choices={view.props.choices}
                        onChange={(_, value) => patchFlowStageLinkRow(idx, { date_types_lnk: value || [] })}
                      />
                    </td>
                    {!readOnly && (
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFlowStageLinkRow(idx)}
                          title="Удалить строку"
                        >
                          <i className="ti ti-trash" />
                        </button>
                      </td>
                    )}
                  </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          {error && <div className="invalid-feedback d-block">{String(error)}</div>}
        </div>
      )
    }

    function renderAttr(attr, horizontal) {
      const access = form_access[attr.name]
      const attr_messages = view.state.form_messages && view.state.form_messages[attr.name]
      const attr_error = view.state.form_errors && view.state.form_errors[attr.name]

      if (!access) {
        return null
      }
      if (view.model_name === 'DocumentTypeRef' && attr.name === 'flow_stage_links_lnk') {
        return renderFlowStageLinksTable(attr)
      }

      const onChangeHandler = (view.model_name === 'DocumentTypeRef' && attr.name === 'document_flow')
        ? (name, value) => {
          const flow = value || null
          const links = Array.isArray(data.flow_stage_links_lnk) ? data.flow_stage_links_lnk : []
          const nextLinks = links.map((row) => {
            const prevStages = Array.isArray(row?.stages_lnk) ? row.stages_lnk : []
            const filteredStages = flow
              ? prevStages.filter((v) => String(v || '').startsWith(`${flow}:`))
              : []
            return { ...row, stages_lnk: filteredStages }
          })
          view.setState({
            form_data: {
              ...data,
              document_flow: flow,
              flow_stage_links_lnk: nextLinks,
            },
          })
        }
        : view.formChange

      return (
        <AttrInput
          key={attr.name}
          data_type={attr.data_type}
          choice_name={attr.choice_name}
          widget={attr.widget}
          choices={view.props.choices}
          name={attr.name}
          title={attr.title}
          rows={attr.rows}
          message={attr_messages}
          error={attr_error}
          value={data[attr.name]}
          access={access}
          inner_attrs={attr.inner_attrs}
          tags={false}
          horizontal={horizontal || false}
          onChange={onChangeHandler}
        />
      )
    }

    function renderGroup(item, idx) {
      const group_title = item[0]
      const attr_names = item[1]
      const wide_attrs = []
      const short_attrs = []
      const attr_names_allowed = attr_names.filter((value) => {
        if (view.model_name === 'DocumentTypeRef' && value === 'flow_stage_links_lnk') return false
        return form_access_names.includes(value)
      })

      if (attr_names_allowed.length === 0) {
        return null
      }

      attr_names_allowed.forEach((attr_name) => {
        let attr = attrs[attr_name]
        if (!attr && view.model_name === 'DocumentTypeRef' && attr_name === 'flow_stage_links_lnk') {
          attr = {
            name: 'flow_stage_links_lnk',
            title: 'Связь документов с этапами документооборота',
            data_type: 'table',
            inner_attrs: [
              {
                name: 'document_name',
                title: 'Документ',
                data_type: 'string',
              },
              {
                name: 'is_required',
                title: 'Обязательный документ',
                data_type: 'bool',
              },
              {
                name: 'stages_lnk',
                title: 'Этапы',
                data_type: 'm2m_string',
                choice_name: 'ProjectState',
                widget: 'select2',
              },
              {
                name: 'track_validity_period',
                title: 'Учитывать срок действия',
                data_type: 'bool',
              },
              {
                name: 'date_types_lnk',
                title: 'Тип даты',
                data_type: 'm2m_string',
                choice_name: 'DocumentTypeDateType',
                widget: 'select2',
              },
            ],
          }
        }
        if (!attr) {
          return
        }
        if (attr.data_type === 'table' || (attr.tags && attr.tags.includes('form_wide'))) {
          wide_attrs.push(attr)
        } else {
          short_attrs.push(attr)
        }
      })

      return (
        <div className="card mb-3 form-sm" key={idx}>
          <div className="card-body p-3">
            <h5 className="card-title">{group_title}</h5>
            <div className="card-text">
              <div className="row">
                {split_list(short_attrs, 2).map((group, gidx) => (
                  <div className="col-md-6" key={gidx}>
                    {group.map((attr) => renderAttr(attr, true))}
                  </div>
                ))}
                {wide_attrs.length > 0 && (
                  <div className="col-md-12" key={`wide-${idx}`}>
                    {wide_attrs.map((attr) => renderAttr(attr, false))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        {this.renderContentLeftAction()}
        {view.state.notifications && (
          <div className="notifications-wrapper">
            {view.state.notifications.map(([type, text], index) => (
              <div key={index} className={`alert ${type}`}>
                {text}
              </div>
            ))}
          </div>
        )}
        {(this.props.form_schema || []).map(renderGroup)}
        {this.model_name === 'DocumentTypeRef' && (
          <div className="card mb-3 form-sm" key="doc-type-flow-links-block">
            <div className="card-body p-3">
              <h5 className="card-title">Связь документов с этапами документооборота</h5>
              <div className="card-text">
                {renderFlowStageLinksTable({
                  name: 'flow_stage_links_lnk',
                  title: 'Связь документов с этапами документооборота',
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  hasPerm(perm) {
    return this.state.perms && this.state.perms.includes(perm)
  }

  renderContentLeftAction() {
    if (this.model_name === 'DepartmentTypeObjectType') {
      return null
    }
    // Запрещаем удалять, если документ создают.
    const isCreate = this.state.id === 0
    return (
      <div className="card mb-3" key="actions">
        <div className="card-body p-2">
          <span className="btn btn-outline-primary waves-effect p-2 me-2" onClick={this.saveObject}>
            <span className="ti ti-xs ti-check me-1"></span>
            Сохранить
          </span>
          {!isCreate && this.hasPerm("delete") && (
            <button className="btn btn-outline-danger waves-effect p-2 me-2" onClick={this.deleteObject}>
              <span className="ti ti-xs ti-trash me-1"></span>
            Удалить</button>
          )}
        </div>
      </div>
    )
  }

  renderTopPanelRightItems() {
    if (this.authorized) {
      return (
        <AuthorizedDropDownMeny
          userTitle={this.user_title}
          onLogout={this.logout}
        />
      )
    }
    return <UnauthorizedDropDownMenu/>
  }
}

export default wrapView(BaseAdminModelView, stateToProps)
